import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Eraser = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M5.84719 11.3278L3.41519 13.7429C3.14934 14.007 3 14.3651 3 14.7385C3 15.112 3.14934 15.4701 3.41519 15.7342L7.17592 19.4689C7.84077 20.1291 8.74249 20.5 9.68272 20.5C10.6229 20.5 11.5247 20.1291 12.1895 19.4689L13.1169 18.5479M5.84719 11.3278L13.7303 3.5L21 10.7194L13.1169 18.5479M5.84719 11.3278L13.1169 18.5479'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M5.84719 10.8278L3.41519 13.2429C3.14934 13.507 3 13.8651 3 14.2385C3 14.612 3.14934 14.9701 3.41519 15.2342L7.17592 18.9689C7.84077 19.6291 8.74249 20 9.68272 20C10.6229 20 11.5247 19.6291 12.1895 18.9689L13.1169 18.0479M5.84719 10.8278L13.7303 3L21 10.2194L13.1169 18.0479M5.84719 10.8278L13.1169 18.0479'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6 11L3 14L9 20H10L13 18L6 11Z'
          fill='currentColor'
          stroke='currentColor'
        />
      </>
    )}
  </IconBase>
);
